import { render, staticRenderFns } from "./StepsProgressBar.vue?vue&type=template&id=6b8df8c8&"
import script from "./StepsProgressBar.vue?vue&type=script&lang=ts&"
export * from "./StepsProgressBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports